import { useLocation } from 'react-router';

import { useMutation } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import {
  type AnswerSource,
  searchClickFeedbackMutation,
} from '@cfa/pathway-fe-shared/xp';

import { searchFeedbackContextAtom } from './state';

/** Doc link from AI search with `from=search` and return URL for new-tab back nav. */
export const useSearchDocLink = (documentId: string): string => {
  const { pathname, search } = useLocation();
  const backUrl = encodeURIComponent(`${pathname}${search}`);

  return `/doc/${documentId}?from=search&backUrl=${backUrl}`;
};

/** Fires search-click-feedback when a user clicks an AI search source. */
export const useSearchClickFeedback = () => {
  const feedbackContext = useAtomValue(searchFeedbackContextAtom);
  const { mutate } = useMutation(searchClickFeedbackMutation());

  return (source: AnswerSource) => {
    if (!feedbackContext?.queryId) return;

    mutate({
      query: {
        queryId: feedbackContext.queryId,
        resultId: source.id,
      },
    });
  };
};
